<template>
  <v-date-picker :value="value === undefined || value === null || value === '' ? null : moment(value).format('YYYY/MM/DD')" @input="$emit('input', $event===undefined ? undefined : moment($event).format('YYYY-MM-DD'))" >
    <template v-slot="{ inputValue, inputEvents }">
      <div style='display: inline-block'>
	<input :value="inputValue" v-on="inputEvents" style='max-width: 100px; text-align: center' :required="required" />
      </div>
    </template>
  </v-date-picker>
</template>

<script>
import VDatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    name: "entry",
    components : {
	VDatePicker
    },
    props : {
	value :  { type: [String, Date] },
	required : { type: Boolean },
    }
}
</script>
